
"use strict";

import "babel-polyfill";
import coreFactory from "./common/core";
import sandboxFactory from "./common/sandbox";

// Modules:
import weeklyPeriodSelectsFactory from "./tv-player-report/weekly-period-selects-open";
import stationsSelectFactory from "./top-programmes/all-stations-select";
import liveStreamingReport from "./tv-player-report/live-streaming-open";
import moreInfo from "./top-programmes/more-info";

const core = coreFactory(window.jQuery, sandboxFactory);

core.createModule(
    "period_selects",
    weeklyPeriodSelectsFactory("tv-player-report/get-live-streaming-by-channel-available-weeks", {
        weeksInterval: 4,
        limitPeriod: "201605270101"
    })
);
core.createModule(
    "stations_select",
    stationsSelectFactory("tv-player-report/get-channels-live-streaming", {
        historical: false
    })
);
core.createModule(
    "live_streaming_channels",
    liveStreamingReport(
        "tv-player-report/live-streaming-channels-by-broadcaster-and-platform",
        {
            labelTableName: 'Channel name',
            csvName: 'Live-streaming-channels-4-weeks.csv'
        }
    )
);

core.createModule("moreInfo", moreInfo);

core.startAll();